// extracted by mini-css-extract-plugin
export default {"collectionProducts__listButtons_button":"Button_collectionProducts__listButtons_button__+57rd","bgColor":"Button_bgColor__+OLZV"};